import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';
import '../css/common/tab-list.css';

import '../css/nest-menu.css';
import '../css/card-block.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import { ARTICLE_NUMBER_PER_PAGE, uploadUri } from './appConfig';
import languageBasedTag from './languageBasedTag';
import getMediaList from './request/mediaList';
import generateLinkCard from './about/generateLinkCard';
import itemStartFrom from './about/itemStartFrom';
import { currentPage, addPaginationButtons } from './pagination';
import hideLoadingImage from './common/hideLoadingImage';

setup();

document.head.appendChild(
	languageBasedTag(),
);

getMediaList(
	itemStartFrom(
		currentPage,
		ARTICLE_NUMBER_PER_PAGE,
	),
).then((json) => {
	json.reports.forEach((item) => {
		document.querySelector('.section-block > .content').appendChild(
			generateLinkCard(item.id, item.title, item.date, `${uploadUri}/${item.thumb}`),
		);
	});
	addPaginationButtons(json.total, ARTICLE_NUMBER_PER_PAGE);
})
	.then(() => {
		hideLoadingImage();
	})
	.catch((err) => console.error(err));



// WEBPACK FOOTER //
// ./src/js/media.js